import { render, staticRenderFns } from "./Ordnerstruktur.vue?vue&type=template&id=b7d78ec8&scoped=true&"
import script from "./Ordnerstruktur.vue?vue&type=script&lang=js&"
export * from "./Ordnerstruktur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d78ec8",
  null
  
)

export default component.exports